import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';
import './Indexadores.css';

import API_BASE_URL from '../../../../config/api';
const Indexadores = () => {
  const [indexadores, setIndexadores] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    data: '',
    ufm: '',
    juros: '',
    multa: '',
    tx_bancaria: '',
    taxa_protocolo: '',
    data_validade: '',
    data_vencimento: ''
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchIndexadores();
  }, []);

  const fetchIndexadores = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/indexadores`);
      if (!response.ok) throw new Error('Erro ao buscar indexadores');
      const data = await response.json();
      setIndexadores(data);
    } catch (error) {
      console.error('Erro ao buscar indexadores:', error);
      alert('Erro ao carregar indexadores');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const filteredIndexadores = indexadores.filter(idx =>
    idx.data && idx.data.toString().includes(searchTerm)
  );

  const handleNew = () => {
    setEditingId(null);
    setFormData({
      data: new Date().toISOString().split('T')[0],
      ufm: '',
      juros: '',
      multa: '',
      tx_bancaria: '',
      taxa_protocolo: '',
      data_validade: '',
      data_vencimento: ''
    });
    setShowForm(true);
  };

  const handleEdit = (indexador) => {
    setEditingId(indexador.id_indexador);
    setFormData({
      data: indexador.data ? indexador.data.split('T')[0] : '',
      ufm: indexador.ufm,
      juros: indexador.juros,
      multa: indexador.multa,
      tx_bancaria: indexador.tx_bancaria
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este indexador?')) {
      try {
        const response = await fetch(`${API_BASE_URL}/indexadores/${id}`, {
          method: 'DELETE'
        });
        if (!response.ok) throw new Error('Erro ao excluir');
        setIndexadores(indexadores.filter(idx => idx.id_indexador !== id));
      } catch (error) {
        console.error('Erro ao excluir:', error);
        alert('Erro ao excluir indexador');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const url = editingId 
        ? `${API_BASE_URL}/indexadores/${editingId}`
        : `${API_BASE_URL}/indexadores`;
      
      const method = editingId ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!response.ok) throw new Error('Erro ao salvar');

      const savedData = await response.json();

      if (editingId) {
        setIndexadores(indexadores.map(idx => 
          idx.id_indexador === editingId ? { ...savedData, id_indexador: editingId } : idx
        ));
      } else {
        setIndexadores([...indexadores, savedData]);
      }

      setShowForm(false);
      setEditingId(null);
      setFormData({
        data: '',
        ufm: '',
        juros: '',
        multa: '',
        tx_bancaria: '',
        taxa_protocolo: '',
        data_validade: '',
        data_vencimento: ''
      });
    } catch (error) {
      console.error('Erro ao salvar:', error);
      alert('Erro ao salvar indexador');
    } finally {
      setSaving(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined) return '';
    return Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined) return '';
    return Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Indexadores</h1>
        </div>
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Indexador' : 'Novo Indexador'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-row">
              <div className="form-group">
                <label>Data *</label>
                <input
                  type="date"
                  value={formData.data}
                  onChange={(e) => setFormData({...formData, data: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <label>UFM *</label>
                <input
                  type="number"
                  step="0.001"
                  value={formData.ufm}
                  onChange={(e) => setFormData({...formData, ufm: e.target.value})}
                  required
                  placeholder="0.000"
                />
              </div>
            </div>

            <div className="form-row-3">
              <div className="form-group">
                <label>Juros (%)</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.juros}
                  onChange={(e) => setFormData({...formData, juros: e.target.value})}
                  placeholder="0.00"
                />
              </div>

              <div className="form-group">
                <label>Multa (%)</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.multa}
                  onChange={(e) => setFormData({...formData, multa: e.target.value})}
                  placeholder="0.00"
                />
              </div>

              <div className="form-group">
                <label>Taxa Bancária</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.tx_bancaria}
                  onChange={(e) => setFormData({...formData, tx_bancaria: e.target.value})}
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="form-row-3">
              <div className="form-group">
                <label>Taxa Protocolo</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.taxa_protocolo}
                  onChange={(e) => setFormData({...formData, taxa_protocolo: e.target.value})}
                  placeholder="0.00"
                />
              </div>

              <div className="form-group">
                <label>Data Validade</label>
                <input
                  type="date"
                  value={formData.data_validade}
                  onChange={(e) => setFormData({...formData, data_validade: e.target.value})}
                />
              </div>

              <div className="form-group">
                <label>Data Vencimento</label>
                <input
                  type="date"
                  value={formData.data_vencimento}
                  onChange={(e) => setFormData({...formData, data_vencimento: e.target.value})}
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={() => setShowForm(false)}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                <FaSave /> {saving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Buscar por data..."
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <div className="table-info">
              {filteredIndexadores.length} registros encontrados
            </div>
            <button className="btn-primary" onClick={handleNew}>
              <FaPlus /> Novo Indexador
            </button>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table indexadores-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-data">Data</th>
                  <th className="col-valor">UFM</th>
                  <th className="col-valor">Juros (%)</th>
                  <th className="col-valor">Multa (%)</th>
                  <th className="col-data">Validade</th>
                  <th className="col-data">Vencimento</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>Carregando...</td>
                  </tr>
                ) : filteredIndexadores.length === 0 ? (
                  <tr>
                    <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                      <div className="empty-state">
                        <div className="empty-state-icon">
                          <FaSearch size={32} />
                        </div>
                        <h3>Nenhum indexador encontrado</h3>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filteredIndexadores.map(idx => (
                    <tr key={idx.id_indexador}>
                      <td className="col-id">{idx.id_indexador}</td>
                      <td className="col-data">{formatDate(idx.data)}</td>
                      <td className="col-valor">{formatNumber(idx.ufm)}</td>
                      <td className="col-valor">{formatCurrency(idx.juros)}%</td>
                      <td className="col-valor">{formatCurrency(idx.multa)}%</td>
                      <td className="col-data">{formatDate(idx.data_validade)}</td>
                      <td className="col-data">{formatDate(idx.data_vencimento)}</td>
                      <td className="col-acoes">
                        <div className="action-buttons">
                          <button
                            className="btn-edit"
                            onClick={() => handleEdit(idx)}
                            title="Editar"
                          >
                            <FaEdit />
                          </button>
                          <button
                            className="btn-delete"
                            onClick={() => handleDelete(idx.id_indexador)}
                            title="Excluir"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Indexadores;
